import { CommonResponse } from "../Types/CommonResponse";
import * as $ from "jquery";
import jqXHR = JQuery.jqXHR;

export interface IFavouritesResponse extends CommonResponse {
  value: number;
  msg: string;
}


export class FavouritesAPI {
  public static add(id): jqXHR<IFavouritesResponse> {
    return $.get(`${id}`);
  }
  public static remove(id): jqXHR<IFavouritesResponse> {
    return $.get(`${id}`);
  }
  public static clear(lang): jqXHR<IFavouritesResponse> {
    const langModified = lang.toString().split('/')[1]; // TODO: Zmodyfikować te metode tak by pobierała język poprzez funkcję getCurrentLanguage() z Core/Languages
    return $.get(`/${lang}/favourites/delete_all`);
  }
}
import { CommonResponse } from "../Types/CommonResponse";
import * as $ from "jquery";
import jqXHR = JQuery.jqXHR;

export interface IFavouritesResponse extends CommonResponse {
  value: number;
  msg: string;
}


export class FavouritesAPI {
  public static add(id): jqXHR<IFavouritesResponse> {
    return $.get(`${id}`);
  }
  public static remove(id): jqXHR<IFavouritesResponse> {
    return $.get(`${id}`);
  }
  public static clear(lang): jqXHR<IFavouritesResponse> {
    const langModified = lang.toString().split('/')[1]; // TODO: Zmodyfikować te metode tak by pobierała język poprzez funkcję getCurrentLanguage() z Core/Languages
    return $.get(`/${lang}/favourites/delete_all`);
  }
}
